import React, { useState, useMemo } from 'react'
import Image from 'next/image'

const getPlaceholder = (name = '') => {
  // Use the challenge name to deterministically select a placeholder
  // This ensures server and client render the same placeholder
  const sum = name.split('').reduce((acc, char) => acc + char.charCodeAt(0), 0);
  const placeholderNum = (sum % 2) + 1; // Either 1 or 2
  return `/challenge-placeholders/placeholder-${placeholderNum}.jpg`
}

const HeaderImage = ({ image, name }) => {
  const [error, setError] = useState(false)
  
  // Memoize the placeholder to ensure it doesn't change between renders
  const placeholder = useMemo(() => getPlaceholder(name), [name]);
  
  return <Image
    width={0} height={0}
    alt={name}
    fill={true}
    src={image && !error ? `${process.env.CDN}/${image}` : placeholder} 
    sizes="(min-width: 768px) 100px, 100px"
    className='rounded-md mx-auto w-auto object-cover object-center'
    onError={() => setError(true)}
  />
}

export default HeaderImage